import { Inject, Injectable } from '@angular/core';
import { CONFIG } from '@domgen/dgx-fe-config';
import { AppConfig } from '../models/config/app-config.type';

@Injectable({
  providedIn: 'root',
})
export class Claims2_0WhitelistService {
  constructor(@Inject(CONFIG) private readonly config: AppConfig) {}

  checkValidUser(email: string): boolean {
    if (this.config.claimsWhitelistAccounts) {
      return this.config.claimsWhitelistAccounts.some(
        (pattern) => email.match(pattern) !== null
      );
    }
    return true;
  }
}
